// extracted by mini-css-extract-plugin
module.exports = {"noBens":"NoBeneficiary_noBens__1wC2N"};